'use client'

import { useMedia } from 'react-use'
import type { MediaQueryProps } from './types'

export default function MediaQuery(props: MediaQueryProps) {
  const { children, fallback, query } = props

  const matches = useMedia(query)

  return matches ? children : fallback
}
